import React from "react";
import { Box } from "@mui/material";
import { Dashboard2ManageColleaguesLink } from "./Dashboard2ManageColleaguesLink";

export const Dashboard2ScheduleManageColleaguesControl: React.FC = () => (
  <Box
    sx={{ display: "inline-flex", alignItems: "center", flexShrink: 0 }}
    data-testid="dashboard2-schedule-manage-colleagues-control"
  >
    <Dashboard2ManageColleaguesLink />
  </Box>
);
